<template>
  <div
    class="fit-loading"
    :class="{
      'flex-center': !innerhidden,
      'loading-show': !innerhidden,
      'page-loading': innerpageLoading,
    }"
  >
    <div class="loading-cnt">
      <span v-if="innerlogo === 'default'" class="loading-logo"></span>
      <img v-if="innerlogo && innerlogo !== 'default'" class="loading-logo" :src="innerlogo" />
      <div class="loading-txt">{{ innertext }}</div>
      <span v-if="innerloadingIcon === 'default'" class="loading-icon"></span>
      <img v-if="innerloadingIcon && innerloadingIcon !== 'default'" class="loading-icon" :src="innerloadingIcon" />
    </div>
  </div>
</template>
<script>
import base from '../../mixins/base.js';
export default {
  name: 'fit-loading',
  mixins: [base],
  props: {
    hidden: {
      type: Boolean,
      default: true,
    },
    pageLoading: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      default: 'WeChat Pay',
    },
    logo: {
      type: String,
      default: 'default',
    },
    loadingIcon: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      innerhidden: this.hidden,
      innerpageLoading: this.pageLoading,
      innertext: this.text,
      innerlogo: this.logo,
      innerloadingIcon: this.loadingIcon,
    };
  },
  methods: {
    hide() {
      this.innerhidden = true;
    },
    show(paramObj) {
      for (const key in paramObj) {
        if (this[`inner${key}`]) {
          this[`inner${key}`] = paramObj[key];
        }
      }
      this.innerhidden = false;
    },
  },
};
</script>
<style lang="less" scoped>
/* reset */
body,
p,
ul,
ol,
li,
dl,
dt,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
form,
fieldset,
legend,
input,
select,
textarea,
button,
th,
td,
menu {
  margin: 0;
  padding: 0;
}
h1,
h2,
h3,
h4,
h5,
h6,
input,
textarea,
select,
button,
label {
  font-size: 100%;
  font-weight: 400;
}
input,
textarea,
select,
button,
label {
  vertical-align: middle;
}
ul,
dl,
ol {
  list-style: none;
}
img,
fieldset,
input[type='submit'] {
  border: none;
}
input,
textarea {
  outline: none;
  background: transparent;
  vertical-align: top;
  cursor: pointer;
  border: none;
}
em,
i {
  font-style: normal;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
button {
  cursor: pointer;
  border: none;
}
textarea {
  word-wrap: break-word;
  resize: none;
  font-family: inherit;
}
input,
textarea,
select {
  -webkit-appearance: none;
  outline: none;
  border-radius: 0;
}
::-webkit-input-placeholder {
  color: #c7c7cd;
  font-weight: normal !important;
}
input[type='text']:disabled {
  opacity: 1;
}
select {
  background-color: #fff !important;
}
html,
body {
  height: 100%;
  background-color: #efeff4;
}
body {
  min-width: 320px;
  font-size: 16px;
  line-height: 1.2;
  -webkit-text-size-adjust: none;
  font-family: 'Helvetica Neue', Helvetica, STHeiTi, sans-serif;
  -webkit-text-size-adjust: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.04);
  overflow-x: hidden;
}
input[type='number'] {
  -webkit-user-select: text;
}
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
a,
button,
input,
img {
  -webkit-touch-callout: none;
  outline: none;
}
a,
button,
input,
select,
textarea {
  -webkit-tap-highlight-color: rgba(130, 130, 130, 0);
}
a {
  text-decoration: none;
  color: #5b6e96;
}
/* a:hover { color:#00A7EE;} */

/* color and align */
.gray {
  color: #888;
}
.red {
  color: #ff3b30;
}
.green {
  color: #04be02;
}
.orange {
  color: #ff8a01;
}
.t-center {
  text-align: center;
}
.t-right {
  text-align: right;
}
.hide {
  display: none !important;
}

/* flex */
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.flex-v {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}
.flex-1 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.flex-pack-justify,
.flex-h-justify {
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.flex-pack-center,
.flex-h-hcenter {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.flex-align-center,
.flex-h-vcenter {
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.flex-justify {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.flex-p-center {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.flex-a-center {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.flex-center {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}

/* 1px border */
.border,
.border-top,
.border-bottom,
.border-left,
.border-right {
  position: relative;
}
.border-top:before,
.border-bottom:after {
  position: absolute;
  content: '';
  top: 0;
  left: 0;
  right: 0;
  height: 0px;
  color: #c8c8c8;
  border-top: 1px solid #c8c8c8;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.border-bottom:after {
  top: auto;
  bottom: 0;
}
.border-left:before,
.border-right:after {
  position: absolute;
  content: '';
  top: 0;
  bottom: 0;
  left: 0;
  width: 0px;
  color: #c8c8c8;
  border-left: 1px solid #c8c8c8;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleX(0.5);
  transform: scaleX(0.5);
}
.border-right:after {
  left: auto;
  right: 0;
}

/* clearfix */
.clearfix::after {
  display: block;
  content: '';
  clear: both;
}

.fit-loading {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.2);
  text-align: center;
  z-index: 999;
}
.fit-loading.page-loading {
  background-color: rgb(255, 255, 255);
}
.fit-loading.loading-show {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.fit-loading .loading-cnt {
  margin: 0 auto;
  width: 176px;
  padding: 25px 0 18px 0;
  -webkit-box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  overflow: hidden;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.7);
}
.fit-loading .loading-logo {
  display: inline-block;
  height: 35px;
  width: 40px;
}
.fit-loading span.loading-logo {
  background: url(../../assets/image/loading/wechat_wallet_logo.png) no-repeat;
  background-size: auto 100%;
}
.fit-loading .loading-txt {
  padding: 13px 10px 20px 10px;
  font-size: 16px;
}
.fit-loading .loading-icon {
  display: inline-block;
  height: 6px;
  width: 27px;
}
.fit-loading span.loading-icon {
  background: url(../../assets/image/loading/loading.gif) no-repeat;
  background-size: auto 100%;
}
.fit-loading img {
  vertical-align: baseline;
}
</style>
